//  Purpose: Configuration file for the app
import type { OauthConfig } from './user'

export const config: OauthConfig & { id: string } = {
    client_name: import.meta.env.VITE_CLIENT_NAME,
    base_url: import.meta.env.VITE_BASE_URL,
    authority: import.meta.env.VITE_AUTHORITY,
    client_id: import.meta.env.VITE_CLIENT_ID,
    authorization_endpoint: import.meta.env.VITE_AUTHORIZATION_ENDPOINT,
    redirect_uri: import.meta.env.VITE_REDIRECT_URI,
    post_logout_redirect_uri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI,
    token_endpoint: import.meta.env.VITE_TOKEN_ENDPOINT,
    refresh_token_endpoint: import.meta.env.VITE_REFRESH_TOKEN_ENDPOINT,
    response_type: import.meta.env.VITE_RESPONSE_TYPE,
    id: "test"
};